import { render, staticRenderFns } from "./BenefitsMtRuTinkoff.vue?vue&type=template&id=40007111"
import script from "./BenefitsMtRuTinkoff.vue?vue&type=script&lang=js"
export * from "./BenefitsMtRuTinkoff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports